<script>
import widgetsElement from "./widget-element-tile.vue";
import WidgetListRowHeader from "./widget-list-row-header.vue";

export default {
    name: "widgets-list-row-view",
    components: {WidgetListRowHeader, widgetsElement},
    props: {
        widgets: Array,
        viewPrivilege: String,
        managePrivilege: String,
    },
    computed: {
        translations() {
            return {
                added: Lang.langGet("Added at"),
                name: Lang.langGet("Name"),
                version: Lang.langGet("Version"),
                author: Lang.langGet("Author"),
                description: Lang.langGet("Description"),
            }
        }
    }
}
</script>

<template>
    <div>
        <widget-list-row-header />
        <widgets-element v-for="(widget,key) in widgets"
            mode="list"
            :key="key"
            :widget="widget"
            :view-privilege="viewPrivilege"
            :manage-privilege="managePrivilege"
        />
    </div>
</template>

<style>
    .widget-element-row-header {
        display: grid;
        grid-template-columns: 0.1fr 0.1fr 0.5fr 0.2fr 0.5fr 1.5fr 0.5fr 0.5fr;
        font-weight: bold;
    }

    .widget-element-row-header .widget-element-row-cell {
        padding: 8px;
        text-align: left;
        border-bottom: 2px solid black;
    }

    .widget-element-row {
        display: grid;
        grid-template-columns: 0.1fr 0.1fr 0.5fr 0.2fr 0.5fr 1.5fr 0.5fr 0.5fr;
    }

    .widget-element-row .widget-element-row-cell {
        padding: 8px;
        text-align: left;
        align-self: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .widget-element-row:hover {
        background-color: var(--project-table-hover-color) ;
        box-shadow: inset 0 0 0 9999px var(--project-table-hover-color) !important;
    }

    .widget-element-row:nth-of-type(odd) {
        background-color: #e8e8e8 !important;
    }
</style>
